import { createSelector } from 'reselect'
import convertDateToUTC from '../utility/convertDateToUTC'
import createDateAsUTC from '../utility/createDateAsUTC'

const getISOString = value => new Date(value).toISOString()
const getISOStringUTC = value => createDateAsUTC(new Date(value)).toISOString()

const getDatetimes = (state, layerName) => {
  return state.layer.times[layerName]
}

const getFormatter = (state, layerName, formatter) => {
  // return formatter || (value => new Date(value).toISOString())
  return formatter || getISOString
}

export const makeGetDatetime = () => {
  return createSelector(
    [getDatetimes, getFormatter],
    (datetimes, formatter) => {
      if (datetimes) {

        // console.log(datetimes)
        // console.log(formatter(datetimes))
        // console.log(formatter)
        return formatter(datetimes)
      } else {
        return null
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/datetimeSelector.js